/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send another`)
};

const es_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar otro`)
};

const de_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere senden`)
};

const nl_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog een versturen`)
};

const fr_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En envoyer un autre`)
};

const it_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia un altro`)
};

const pt_br2_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar outro`)
};

const pt_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar outro`)
};

const ja_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もう一件送る`)
};

const zh_contact_send_another = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再发一条`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_send_another = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_send_another(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_send_another", locale)
	if (locale === "en") return en_contact_send_another(inputs)
	if (locale === "es") return es_contact_send_another(inputs)
	if (locale === "de") return de_contact_send_another(inputs)
	if (locale === "nl") return nl_contact_send_another(inputs)
	if (locale === "fr") return fr_contact_send_another(inputs)
	if (locale === "it") return it_contact_send_another(inputs)
	if (locale === "pt-BR") return pt_br2_contact_send_another(inputs)
	if (locale === "pt") return pt_contact_send_another(inputs)
	if (locale === "ja") return ja_contact_send_another(inputs)
	return zh_contact_send_another(inputs)
};